// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__br5v0","Footer_logo":"Footer_Footer_logo__M9FF_","Footer_heading":"Footer_Footer_heading__mfn_H","Footer_SocialLinks":"Footer_Footer_SocialLinks__8uzrM"};